import { render, staticRenderFns } from "./FilmList.vue?vue&type=template&id=0a5cfa22&scoped=true&"
import script from "./FilmList.vue?vue&type=script&lang=ts&"
export * from "./FilmList.vue?vue&type=script&lang=ts&"
import style0 from "./FilmList.vue?vue&type=style&index=0&id=0a5cfa22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5cfa22",
  null
  
)

export default component.exports